import { css } from '@emotion/core'
import * as React from 'react'

interface IProps {
  children: React.ReactNode
  onSubmit: () => void
}

const formStyles = css`
  width: 100%;
`

export default function Form(props: IProps) {
  const { children, onSubmit } = props

  return (
    <form
      css={formStyles}
      onSubmit={event => {
        event.preventDefault()
        onSubmit()
      }}
    >
      {children}
    </form>
  )
}
